import * as angular from "angular";
import {SetApProgramsController} from "./set-ap-programs.controller.ts";
const templateUrl = require("./set-ap-programs.html");

export const setApPrograms: angular.IDirective = {
    templateUrl: templateUrl,
    controller: SetApProgramsController,
    controllerAs: "vm",
    bindToController: true,
    scope: {}
};


/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./app/set-ap-programs/set-ap-programs.ts
 **/